export default "__VITE_ASSET__BkYZ9DSh__"